import { Plugin } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";

/** `settings.placeholder` is stored as HTML (e.g. `<h1>Click to add text</h1>`); show only its text. */
const placeholderText = (html: string | null): string | null => {
  if (!html) return null;
  const text =
    new window.DOMParser()
      .parseFromString(html, "text/html")
      .body.textContent?.trim() ?? "";
  return text || null;
};

export const placeholderPlugin = (placeholder: string | null) => {
  const text = placeholderText(placeholder);
  return new Plugin({
    props: {
      decorations(state) {
        if (!text) return null;
        const { doc } = state;
        const first = doc.firstChild;
        const isEmpty =
          doc.childCount === 1 &&
          !!first &&
          first.isTextblock &&
          first.content.size === 0;
        if (!isEmpty) return null;
        return DecorationSet.create(doc, [
          Decoration.node(0, first.nodeSize, {
            class: "pm-placeholder",
            "data-placeholder": text,
          }),
        ]);
      },
    },
  });
};
